import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../../../cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { InsuranceDetails } from '@cp-mx/common';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<
    InsuranceDetails,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'insuranceDetails',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default reducer;
export const fetchInsuranceDetails = fetchData;
